import { render, staticRenderFns } from "./category-radio-group.vue?vue&type=template&id=6849b668"
import script from "./category-radio-group.vue?vue&type=script&lang=js"
export * from "./category-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports